/* WG product page — variant logic, media rail, zoom, ajax ATC, related. */
(function () {
  'use strict';
  if (window.__wgProduct) return;
  window.__wgProduct = true;

  function init() {
    var section = document.querySelector('[data-wg-product]');
    if (!section || section.__wgInit) return;
    section.__wgInit = true;

    var variantsEl = document.querySelector('[data-wg-variants]');
    var moneyEl = document.querySelector('[data-wg-money]');
    var variants = [];
    var moneyFormat = '${{amount}}';
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {}
    try {
      moneyFormat = JSON.parse(moneyEl.textContent);
    } catch (e) {}

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var track = section.querySelector('[data-wg-pm-track]');
    var slides = track ? [].slice.call(track.querySelectorAll('.wg-pm-slide')) : [];
    var count = section.querySelector('[data-wg-pm-count]');
    var priceEl = section.querySelector('[data-wg-price]');
    var compareEl = section.querySelector('[data-wg-compare]');
    var idInput = section.querySelector('[data-wg-variant-id]');
    var atc = section.querySelector('[data-wg-atc]');
    var atcLabel = section.querySelector('[data-wg-atc-label]');
    var note = section.querySelector('[data-wg-atc-note]');
    var backorder = section.querySelector('[data-wg-backorder]');
    var backorderProperty = section.querySelector('[data-wg-backorder-property]');
    var groups = [].slice.call(section.querySelectorAll('[data-wg-option]'));

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      var noDec = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    /* ── media carousel: transform track, pointer-drag, seamless loop ──
       Native scroll-snap can neither wrap past the last slide nor be
       dragged with a mouse, so the rail is driven by transform. Clones of
       the first/last slides sit at each end; after animating onto a clone
       we jump (transition-off) to its real twin, so forward/back loop with
       no visible seam. Pointer events unify mouse + touch. */
    var real = slides.slice();
    var N = real.length;
    var viewport = track ? track.parentNode : null;
    var prev = section.querySelector('[data-wg-pm-prev]');
    var next = section.querySelector('[data-wg-pm-next]');
    var dragMoved = false;
    var p = 0; // DOM index of the on-screen slide

    if (track && N > 1) {
      var cloneFirst = real[0].cloneNode(true);
      var cloneLast = real[N - 1].cloneNode(true);
      cloneFirst.setAttribute('data-clone', '1');
      cloneLast.setAttribute('data-clone', '1');
      track.insertBefore(cloneLast, real[0]);
      track.appendChild(cloneFirst);
      p = 1; // real slides now occupy DOM indices 1..N
    }

    function setX(animate) {
      if (!track) return;
      track.style.transition = animate
        ? 'transform 0.42s cubic-bezier(0.22,0.61,0.36,1)'
        : 'none';
      track.style.transform = 'translateX(' + -p * 100 + '%)';
    }

    function realIndex() {
      if (N <= 1) return 0;
      var i = p - 1;
      if (i < 0) i = N - 1;
      if (i > N - 1) i = 0;
      return i;
    }

    function updateCount() {
      if (count && N) count.textContent = realIndex() + 1 + ' / ' + N;
    }

    function normalize() {
      if (N <= 1) return;
      if (p === N + 1) { p = 1; setX(false); }
      else if (p === 0) { p = N; setX(false); }
    }

    function step(delta) {
      if (N <= 1) return;
      p += delta;
      setX(true);
      updateCount();
    }

    if (track && N > 1) {
      setX(false);
      track.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') normalize();
      });
    }
    updateCount();

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if (track && N > 1) {
      var dragging = false, startX = 0, dx = 0, w = 1;
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        dragMoved = false;
        startX = e.clientX;
        dx = 0;
        w = (viewport ? viewport.clientWidth : track.clientWidth) || 1;
        track.classList.add('is-dragging');
        track.style.transition = 'none';
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        if (Math.abs(dx) > 6) dragMoved = true;
        track.style.transform = 'translateX(calc(' + -p * 100 + '% + ' + dx + 'px))';
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var threshold = Math.max(w * 0.18, 40);
        if (dx <= -threshold) step(1);
        else if (dx >= threshold) step(-1);
        else setX(true);
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    }

    function goToMedia(mediaId) {
      if (!mediaId || N <= 1) return;
      for (var i = 0; i < N; i++) {
        if (Number(real[i].getAttribute('data-media-id')) === mediaId) {
          p = i + 1;
          setX(true);
          updateCount();
          return;
        }
      }
    }

    /* ── zoom (suppressed if the pointer was dragging) ───────────── */
    var zoom = document.querySelector('[data-wg-zoom]');
    var zoomImg = zoom && zoom.querySelector('[data-wg-zoom-img]');
    if (zoom && zoomImg && track) {
      track.addEventListener('click', function (e) {
        if (dragMoved) { dragMoved = false; return; }
        var slide = e.target.closest('.wg-pm-slide');
        if (!slide) return;
        var full = slide.getAttribute('data-full');
        if (!full) return;
        zoomImg.src = full;
        if (typeof zoom.showModal === 'function') zoom.showModal();
      });
      var close = zoom.querySelector('[data-wg-zoom-close]');
      if (close) close.addEventListener('click', function () { zoom.close(); });
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom) zoom.close();
      });
    }

    /* ── variant selection ────────────────────────── */
    var selected = {};
    groups.forEach(function (g) {
      var pos = Number(g.getAttribute('data-position'));
      var active = g.querySelector('.is-active[data-value], .is-selected[data-value]');
      selected[pos] = active ? active.getAttribute('data-value') : null;
    });

    function findVariant() {
      var positions = Object.keys(selected);
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < positions.length; j++) {
          var pos = Number(positions[j]);
          if (variants[i].options[pos - 1] !== selected[pos]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function markAvailability() {
      groups.forEach(function (g) {
        var pos = Number(g.getAttribute('data-position'));
        [].slice.call(g.querySelectorAll('[data-value]')).forEach(function (btn) {
          var value = btn.getAttribute('data-value');
          var possible = variants.some(function (v) {
            if (v.options[pos - 1] !== value) return false;
            for (var p in selected) {
              if (Number(p) !== pos && selected[p] && v.options[p - 1] !== selected[p]) return false;
            }
            return v.available;
          });
          // color swatches keep their server-side all-OOS strike; only
          // non-color buttons get the contextual unavailable mark
          if (!btn.classList.contains('wg-sw')) {
            btn.classList.toggle('is-unavailable', !possible);
          }
        });
      });
    }

    function apply(userTriggered) {
      var variant = findVariant();
      if (backorder) backorder.textContent = variant ? variant.backorder || '' : '';
      if (backorderProperty) {
        backorderProperty.value = variant ? variant.backorder || '' : '';
        backorderProperty.disabled = !backorderProperty.value;
      }
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      var ptIdInput = section.querySelector('[data-wg-pt-id]');
      if (ptIdInput) {
        ptIdInput.value = variant.id;
        ptIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare > variant.price) {
          compareEl.textContent = money(variant.compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      markAvailability();
      if (userTriggered) {
        // only after user interaction — page always opens on the first photo
        goToMedia(variant.media);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }
    }

    groups.forEach(function (g) {
      var pos = Number(g.getAttribute('data-position'));
      var label = g.querySelector('[data-wg-optvalue]');
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn) return;
        e.preventDefault();
        selected[pos] = btn.getAttribute('data-value');
        [].slice.call(g.querySelectorAll('[data-value]')).forEach(function (x) {
          x.classList.toggle('is-active', x === btn);
          x.classList.toggle('is-selected', x === btn);
        });
        if (label) label.textContent = selected[pos];
        apply(true);
      });
    });

    markAvailability();

    /* ── ajax add to cart ─────────────────────── */
    var form = atc && atc.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.disabled || atc.classList.contains('is-busy')) return;
        atc.classList.add('is-busy');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(idInput.value), quantity: 1, properties: backorderProperty && !backorderProperty.disabled ? { _wg_backorder: backorderProperty.value } : {} }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            atc.classList.remove('is-busy');
            if (note) note.hidden = false;
            fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-wg-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                  el.hidden = !cart.item_count;
                });
                document.dispatchEvent(new CustomEvent('wg:cart:update'));
              })
              .catch(function () {
                document.dispatchEvent(new CustomEvent('wg:cart:update'));
              });
          })
          .catch(function () {
            atc.classList.remove('is-busy');
            form.submit();
          });
      });
    }

    /* ── related products ────────────────────────
       Rendered as real wg-product-cell cards via the section-render
       endpoint so they carry the SAME black quick-add chip + swatches as
       the homepage grid (wg-grid.js, loaded on this page, handles them). */
    var related = document.querySelector('[data-wg-related]');
    if (related) {
      var grid = related.querySelector('[data-wg-related-grid]');
      var pid = related.getAttribute('data-product-id');
      var base = related.getAttribute('data-root') || root;
      if (base.slice(-1) !== '/') base += '/';
      var recUrl =
        base +
        'recommendations/products?section_id=wg-recommendations&intent=related&limit=' +
        (related.getAttribute('data-limit') || '10') +
        '&product_id=' +
        pid;
      fetch(recUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!grid) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cells = Array.prototype.slice.call(doc.querySelectorAll('.wg-cell'));
          if (!cells.length) return;
          grid.innerHTML = '';
          cells.forEach(function (c) { grid.appendChild(c); });
          related.classList.add('has-items');
        })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

